<style lang="less" scoped>
  .content {
    position: relative;
    overflow: hidden;
  }
  .progress {
    position: absolute;
    right: 0;
    top: 16px;
  }
  .number-container {
    .number-row {
      font-size: 120px;
      text-align: center;
      &:nth-of-type(1),
      &:nth-of-type(5) {
        opacity: 0.3;
        font-size: 30px !important;
      }
      &:nth-of-type(2),
      &:nth-of-type(4) {
        opacity: 0.5;
        font-size: 60px !important;
      }
    }
  }
</style>

<template lang="pug">
  .std-layout
    .header
      header-component(
        @click-stop='redirectBack'
        @click-complete='done')
    .content
      progress-component.progress(
        :current='current + 1'
        :max='count'
        :unit='"자리"')
      .number-container
        number-component.number-row(
          v-for='data in display'
          :data='data')
    .footer
      footer-component(
        :time='time'
        :last='isLast'
        @click-next='next'
        @click-prev='prev'
        @click-complete='done')
</template>

<script>
import HeaderComponent from '@/components/header/stop_complete';
import ProgressComponent from '@/components/current_max_progress';
import NumberComponent from '@/components/number_display';
import FooterComponent from '@/components/footer/timer_arrow';

import GameType from '@/game';

export default {
  data() {
    return {
      current: 0,
      score: 0,
      time: 0,
    };
  },
  computed: {
    isLast() {
      return this.maxGroupCount - 1 === this.current;
    },
    localStorageKey() {
      const arr = [GameType.mode.time, GameType.game.number];
      return arr.join('.');
    },
    endTime() {
      const minute = this.$store.state.app.time;
      return 60 * minute;
    },
    display() {
      const result = [];
      const current = this.current;
      let index = 4;
      for (let i = current - 2; i <= current + 2; i += 1) {
        if (this.answer[i]) {
          result[index] = this.answer[i];
        } else {
          result[index] = [];
        }
        index -= 1;
      }
      return result;
    },
    answer() {
      return this.$store.state.app.answer;
    },
    count() {
      const count = this.$store.state.app.count;
      const units = this.units;
      return Math.ceil(count / units);
    },
    units() {
      return this.$store.state.app.units;
    },
    maxGroupCount() {
      return this.answer.length;
    },
  },
  methods: {
    addBestRecord(time, score) {
      const data = JSON.stringify({ time, score });
      this.$localStorage.set(this.localStorageKey, data);
    },
    loadBestRecord() {
      const data = JSON.parse(this.$localStorage.get(this.localStorageKey));
      return this.$localStorage.get(this.localStorageKey) ? data : { score: 0, time: 0 };
    },
    addStoreBestScore() {
      const data = this.loadBestRecord();
      this.$store.commit('setBestScore', data.score);
    },
    addStoreBestTime() {
      const data = this.loadBestRecord();
      this.$store.commit('setBestTime', data.time);
    },
    redirectBack() {
      this.$router.go(-1);
    },
    progressTimer() {
      this.time += 1;
      if (this.time >= this.endTime) {
        this.done();
      }
    },
    prev() {
      if (this.current > 0) {
        this.removeScore(this.answer[this.current].length);
        this.current -= 1;
      }
    },
    next() {
      if (this.current + 1 < this.maxGroupCount) {
        this.current += 1;
        this.addScore(this.answer[this.current].length);
      }
    },
    addScore(score) {
      this.score += score * 1;
    },
    removeScore(score) {
      this.score -= score * 1;
    },
    done() {
      this.$store.commit('setScore', this.score);
      this.$store.commit('setUsedTime', this.time);
      this.setBestRecord();
      this.addStoreBestScore();
      this.addStoreBestTime();
      this.$router.replace('/result');
    },
    setBestRecord() {
      const record = this.loadBestRecord();
      const score = record.score || 0;
      if (score < this.score) {
        this.addBestRecord(this.time, this.score);
      }
    },
  },
  mounted() {
    this.time = 0;
    window.intervalID = setInterval(this.progressTimer, 1000);
    this.addScore(this.answer[this.current].length);
  },
  beforeDestroy() {
    clearInterval(window.intervalID);
  },
  components: {
    HeaderComponent,
    ProgressComponent,
    NumberComponent,
    FooterComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/time/number/start.vue